class FrontendManagementService {
    constructor($cookies, settings, trolleyService) {
        this.$cookies = $cookies;
        this.trolleyService = trolleyService;
        this.frontendManagement = settings.frontendManagement || {};
        this.enableDigitalPay = settings.payment && settings.payment.enableDigitalPay;
    }

    useAngular2PlusCheckout() {
        return (this.frontendManagement.useAngular2PlusCheckout && !this.isAngular2PlusUnavailable() && this.enableDigitalPay) || this.trolleyService.HasPfdItems;
    }

    useAngular2PlusHaveYouForgotten() {
        return this.frontendManagement.useAngular2PlusHaveYouForgotten && !this.isAngular2PlusUnavailable();
    }

    useAngular2PlusQuickReorder() {
        return this.frontendManagement.useAngular2PlusQuickReorder && !this.isAngular2PlusUnavailable();
    }

    isAngular2PlusUnavailable() {
        // When the backend is having issues loading the Angular2Plus frontend,
        // it will set this cookie so we stop trying to redirect to it
        return Boolean(this.$cookies.get('w-isAngular2PlusUnavailable'));
    }
}

FrontendManagementService.$inject = ['$cookies', 'Settings', 'TrolleyService'];

module.exports = { FrontendManagementService };



// WEBPACK FOOTER //
// ./src/common/frontendmanagement/frontend-management.service.js